export class TemplateImage {
    value: string;
    label: string;
    constructor(value: string, label: string) {
        this.value = value;
        this.label = label;
        if(!this.label.length) {
            this.label = this.value;
        }
     }
}